import { OptionKV } from "~styled/selector/Selector";

const TODOS = "Pendiente,PendienteCompania";
export const PENDIENTE = "Pendiente";
export const PENDIENTECOMPANIA = "PendienteCompania";

const estadosSolicitudEmisionOptions: Record<string, string> = {
  [TODOS]: "Todos",
  [PENDIENTE]: "Pendiente de Emisión",
  [PENDIENTECOMPANIA]: "Pendiente en Compañía",
};

const estadosSolicitudEmision: string[] = [PENDIENTE, PENDIENTECOMPANIA];

const estadosSolicitudEmisionFilter: OptionKV<string>[] = [
  { label: estadosSolicitudEmisionOptions[TODOS], value: TODOS },
  {
    label: estadosSolicitudEmisionOptions[PENDIENTE],
    value: PENDIENTE,
  },
  {
    label: estadosSolicitudEmisionOptions[PENDIENTECOMPANIA],
    value: PENDIENTECOMPANIA,
  },
];

export {
  estadosSolicitudEmisionOptions,
  estadosSolicitudEmision,
  estadosSolicitudEmisionFilter,
};
